'use strict';

(function () {
	'use strict';

	soundService.$inject = ['$http', '$q', 'appConfig', 'baseService'];
	angular.module('app.services').factory('soundService', soundService);

	function soundService($http, $q, appConfig, baseService) {
		'ngInject';

		var service = {
			getGroupedData: getGroupedData,
			getScanners: getScanners
		};

		return service;

		////////////////


		function decode(str) {
			return str.replace(/&#(\d+);/g, function (match, dec) {
				return String.fromCharCode(dec);
			});
		}

		function getRawData() {
			var params = {};
			return $http.get(appConfig.soundUrl + '/data', {
				params: params,
				transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('created')),
				cache: false
			}).then(function (result) {
				var data = [];

				result.data.forEach(function (entry) {
					data.push({
						at: entry.created,
						db: parseInt(entry.db),
						scanner_id: entry.scanner_id
					});
				});

				data.sort(function (a, b) {
					// Turn your strings into dates, and then subtract them
					// to get a value that is either negative, positive, or zero.
					return new Date(a.at) - new Date(b.at);
				});

				return data;
			});
		}

		/**
   * 
   */
		function getGroupedData() {

			return $q.all({
				scanners: getScanners(),
				rawData: getRawData()
			}).then(function (result) {
				var values = [];

				result.scanners.forEach(function (entry) {
					values[entry.scanner_id] = [];

					var filteredArray = result.rawData.filter(function (item) {
						return item.scanner_id == entry.scanner_id;
					});
					values[entry.scanner_id] = filteredArray;
				});

				return values;
			});
		}

		/**
   * 
   */
		function getScanners() {
			var params = {};

			return $http.get(appConfig.soundUrl + '/scanners', {
				params: params
			}).then(function (r) {
				var result = r.data;
				result.map(function (item) {
					item.name = decode(item.name);
					item.name_el = decode(item.name_el);
				});
				return result;
			});
		}
	}
})();